import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { AlertLineReportSummaryDTO } from "../../../../models/alert-line-report-summary/alert-line-report-summary-dto";
const ManageAlertLineFooter = ({
  customSummary,
  loading,
}: {
  customSummary?: AlertLineReportSummaryDTO;
  loading: boolean;
}) => {
  const tRP = "components.custom_widget_links.manage_alert_lines.submitted";
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <>
      {Number(customSummary?.submitted) > 0 && !loading ? (
        <Grid style={{ display: "flex", alignItems: "center", gap: "5px", justifyContent: "center", width: "110%" }}>
          <FontAwesomeIcon
            icon={faCircleExclamation}
            color={theme.palette.error.light}
          />
          <Typography
            color={theme.palette.error.light}
            variant="body2"
          >
            {`${t(`${tRP}`)}`.replace("{{numberOfNewAlerts}}", "0")}
          </Typography>
        </Grid>
      ) : (
        <></>
      )}
    </>
  );
};
export default ManageAlertLineFooter;
